import { render, staticRenderFns } from "./Liquidations.vue?vue&type=template&id=ac5ffae2&"
import script from "./Liquidations.vue?vue&type=script&lang=ts&"
export * from "./Liquidations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports